import React, { createContext, useContext, useState } from "react";
import axios from "axios";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("user")) || null
  );
  const [loading, setLoading] = useState(false);

  /* ================= LOGIN ================= */
  const login = async (email, password) => {
    try {
      const response = await axios.post(
        "https://jobs.mpdatahub.com/api/todaytalks-login",
        { email, password }
      );

      if (response.data?.success) {
        setUser(response.data.user || { email });
        localStorage.setItem(
          "user",
          JSON.stringify(response.data.user || { email })
        );
        return { success: true };
      }

      return {
        success: false,
        message: response.data?.message || "Login failed"
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "Login failed"
      };
    }
  };

  /* ================= REGISTER ================= */
  const signup = async (
    name,
    email,
    mobile,
    password,
    dob = "",
    profile_image = ""
  ) => {
    try {
      console.log(name, email, mobile, password, dob, profile_image);

      const response = await axios.post(
        "https://jobs.mpdatahub.com/api/todaytalks-register",
        {
          profile_image,
          name,
          email,
          password,
          dob,
          mobile
        }
      );

      return {
        success: response.data?.success,
        message: response.data?.message || "Registration successful"
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "Signup failed"
      };
    }
  };

  /* ================= FORGOT PASSWORD ================= */
  const forgotPassword = async (email) => {
    try {
      const response = await axios.post(
        "https://jobs.mpdatahub.com/api/todaytalks-forgot-password",
        { email }
      );

      return {
        success: response.data?.success,
        message: response.data?.message
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message || "Failed to send reset email"
      };
    }
  };

  /* ================= RESET PASSWORD ================= */
  const resetPassword = async (email, password, password_confirmation) => {
    try {
      const response = await axios.post(
        "https://jobs.mpdatahub.com/api/todaytalks-reset-password",
        {
          email,
          password,
          password_confirmation
        }
      );

      return {
        success: response.data?.success,
        message: response.data?.message
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message || "Password reset failed"
      };
    }
  };

  /* ================= LOGOUT ================= */
  const logout = () => {
    localStorage.removeItem("user");
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        signup,
        forgotPassword,
        resetPassword,
        logout
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
